import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import InputMask from "react-input-mask";
import Select from "react-select";
import axios from "axios";

import { DropdownIndicator } from "../../../components/header/headerTop/headerSelects/selects";
import { customStyles } from "../../../components/header/headerTop/headerSelects/selects";
import InputPhoto from "../../../cabinet/advertisement/InputPhoto";
import { ArrowLeftIcon } from "../../../components/icons/ArrowLeftIcon";
import { DeleteIcon } from "../../../components/icons/DeleteIcon";
import getHost, { url } from "../../../store/host-store";
import Loader from "../../../components/loader/Loader";
import { token } from "../../../App";
import WorkingTimeRole from "./WorkingTimeRole";

// Опции роли
const options = [
    { value: "admin", label: "Главный администратор" },
    { value: "user", label: "Пользователь" },
    { value: "moderator", label: "Модератор" },
    { value: "tech", label: "Администратор" },
    { value: "ad_moderator", label: "Модератор рекламы" },
    { value: "advertiser", label: "Рекламодатель" },
    { value: "fin_admin", label: "Финансовый администратор" },
    { value: "registrar", label: "Регистратор объявлений" },
];

const EditRole = () => {
    const params = useParams();
    const id = params.id;
    const navigate = useNavigate();

    // объединённый стейт пользователя
    const [userData, setUserData] = useState({
        id: null,
        idAcc: null,
        name: "",
        email: "",
        phone: "",
        password: "",
        role: {},
        avatar: null,
    });

    const [moderatorWorkingHours, setModeratorWorkingHours] = useState(null);
    const [downloadImages, setDownloadImages] = useState([]);
    const [valid, setValid] = useState(true);
    const [success, setSuccess] = useState(false);

    useEffect(() => {
        const fetchUser = async () => {
            try {
                const res = await fetch(
                    getHost({ controller: "user", action: id, expand: "account,workingHours" }),
                    { headers: { Accept: "application/json", Authorization: token } }
                );
                const result = await res.json();
                if (result.success) {
                    const user = result.data;

                    setUserData({
                        id: user.id,
                        idAcc: user.account.id,
                        name: user.name,
                        email: user.email,
                        phone: user.phone,
                        password: "",
                        role: options.find((o) => o.value === user.account.role) || options[0],
                        avatar: user.avatar || null,
                    });

                    if (user.workingHours) {
                        const wh = user.workingHours;

                        const daysMap = {};
                        const days = ["monday","tuesday","wednesday","thursday","friday","saturday","sunday"];

                        days.forEach(day => {
                            if (Array.isArray(wh[day]) && wh[day].length > 0) {
                                const filtered = wh[day]
                                    .filter(i => i.start && i.end)
                                    .map(i => ({
                                        start: i.start,
                                        end: i.end
                                    }));

                                if (filtered.length > 0) {
                                    daysMap[day] = filtered;
                                }
                            }
                        });


                        setModeratorWorkingHours({
                            days: daysMap,
                            startDateException: wh.exclusion_days?.startDateException || null,
                            endDateException: wh.exclusion_days?.endDateException || null
                        });
                    }
                }
            } catch (e) {
                console.error(e);
            }
        };

        fetchUser();
    }, [id]);

    const deleteCurrentImage = (e) => {
        e.preventDefault();
        setUserData(prev => ({ ...prev, avatar: null }));
    };

    const onSave = async () => {
        let selectedImg =
            downloadImages.length > 0
                ? downloadImages[0]
                : userData.avatar
                    ? userData.avatar[0]
                    : null;

        const formData = new FormData();
        formData.append("name", userData.name);
        formData.append("email", userData.email);
        formData.append("phone", userData.phone);
        formData.append("avatar", selectedImg);
        formData.append("password", userData.password);

        if (userData.role.value === "moderator" || userData.role.value === "ad_moderator" && moderatorWorkingHours) {
            formData.append("moderator_working_hours", JSON.stringify(moderatorWorkingHours));
        }

        const dataRole = { role: userData.role.value };

        try {
            const [userRes, accountRes] = await Promise.all([
                axios.put(getHost({ controller: "user", action: id }), formData, {
                    headers: { Accept: "application/json", Authorization: token },
                }),
                axios.put(getHost({ controller: "account", action: userData.idAcc }), dataRole, {
                    headers: { Accept: "application/json", Authorization: token },
                }),
            ]);

            if (userRes.data.success && accountRes.data.success) {
                setSuccess(true);
                setValid(true);
            } else {
                setSuccess(false);
                setValid(false);
            }
        } catch (e) {
            console.error(e);
            setSuccess(false);
            setValid(false);
        }
    };

    const onDelete = async () => {
        try {
            const res = await fetch(getHost({ controller: "user", action: id }), {
                method: "DELETE",
                headers: { Accept: "application/json", Authorization: token },
            });
            const result = await res.json();
            if (result.success) {
                navigate("/admin/roles");
            }
        } catch (e) {
            console.error(e);
        }
    };

    if (!userData.name) return <Loader />;

    return (
        <>
            <div className="admin__layout">
                <div className="admin__edit-category">
                    <div className="admin__edit-category_top">
                        <div>
                            <button title="назад" type="button" className="admin__back-arrow" onClick={() => navigate(-1)}>
                                <ArrowLeftIcon />
                            </button>
                            <h3>{userData.name}</h3>
                        </div>
                        <div className="admin_one-object_top-right">
                            <button type="button" className="admin__btn-transparent" onClick={onDelete}>
                                Удалить
                            </button>
                            <button type="button" className="admin__btn-blue" onClick={onSave}>
                                Сохранить
                            </button>
                        </div>
                    </div>

                    {userData.avatar && (
                        <div className="imagesMultiple">
                            <div className="input_foto_wrap">
                                <img src={url + userData.avatar} alt="" />
                                <button title="delete" type="button" onClick={deleteCurrentImage}>
                                    <DeleteIcon />
                                </button>
                            </div>
                        </div>
                    )}
                    {!userData.avatar && (
                        <InputPhoto images={downloadImages} onLoad={setDownloadImages} onDelete={setDownloadImages} />
                    )}

                    <div className="admin__edit-category_inputs">
                        <input
                            value={userData.name}
                            placeholder="Имя"
                            onChange={(e) => setUserData(prev => ({ ...prev, name: e.target.value }))}
                        />
                        <div className="admin__edit-category_labels-wrapper">
                            <InputMask
                                mask="+7 (999) 999 99 99"
                                placeholder="Телефон"
                                value={userData.phone}
                                onChange={(e) => setUserData(prev => ({ ...prev, phone: e.target.value }))}
                            />
                            <input
                                value={userData.email}
                                placeholder="E-mail"
                                onChange={(e) => setUserData(prev => ({ ...prev, email: e.target.value }))}
                            />
                        </div>
                        <div className="admin__edit-category_labels-wrapper">
                            <Select
                                className="selects"
                                styles={customStyles}
                                components={{ DropdownIndicator }}
                                options={options}
                                value={userData.role}
                                onChange={(role) => setUserData(prev => ({ ...prev, role }))}
                            />
                            <input
                                value={userData.password}
                                placeholder="Новый пароль"
                                onChange={(e) => setUserData(prev => ({ ...prev, password: e.target.value }))}
                            />
                        </div>
                    </div>

                    {!valid && <span className="admin__error">Все поля обязательны для заполнения</span>}
                    {success && <span className="admin__success">Изменения успешно сохранены</span>}
                </div>
            </div>

            { (userData.role.value === "moderator" || userData.role.value === "ad_moderator") && (
                <WorkingTimeRole
                    initialData={moderatorWorkingHours}
                    onChange={setModeratorWorkingHours}
                />
            )}
        </>
    );
};

export default EditRole;